import React from 'react';
import PropTypes from 'prop-types';
import { capitalize } from 'lodash';
import { feeSchedulePrograms as fspUtils } from '@unite-us/client-utils';
import { LineItem } from 'common/display/LineItem';
import { dollarAmount } from 'common/display/Money/DollarAmount';

const FeeScheduleProgramSection = ({ feeScheduleProgram, isLoaded, isCostBased }) => {
  const unitRateValue = feeScheduleProgram.unit_rate ?
    `${dollarAmount(feeScheduleProgram.unit_rate, true)} per ${feeScheduleProgram.unit}` :
    'N/A';

  return (
    <>
      <LineItem field="Contracted Program" isLoaded={isLoaded} dataTestElement="request-contracted-program">
        {feeScheduleProgram.name}
      </LineItem>
      <LineItem field="Payment Approach" isLoaded={isLoaded} dataTestElement="payment-approach">
        {fspUtils.PAYMENT_TYPES[feeScheduleProgram.payment_type]}
      </LineItem>
      {!isCostBased && (
        <>
          <LineItem field="Unit" isloaded={isLoaded} dataTestElement="request-unit">
            {capitalize(feeScheduleProgram.unit)}
          </LineItem>
          <LineItem field="Rate" isLoaded={isLoaded} dataTestElement="request-rate">
            {unitRateValue}
          </LineItem>
        </>
      )}
      <LineItem field="Program Cap" isLoaded={isLoaded} dataTestElement="request-cap">
        {/* eslint-disable-next-line react/no-danger */}
        <div dangerouslySetInnerHTML={{ __html: feeScheduleProgram.cap_information || 'N/A' }} />
      </LineItem>
    </>
  );
};

FeeScheduleProgramSection.propTypes = {
  feeScheduleProgram: PropTypes.shape({
    name: PropTypes.string,
    payment_type: PropTypes.string,
    unit: PropTypes.string,
    unit_rate: PropTypes.number,
    cap_information: PropTypes.string,
  }).isRequired,
  isLoaded: PropTypes.bool.isRequired,
  isCostBased: PropTypes.bool.isRequired,
};

export default FeeScheduleProgramSection;
